import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-auto border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-6xl px-6 py-5 space-y-3">
        <div className="flex flex-col items-center justify-between gap-3 sm:flex-row">
          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} {'HiveFall'}. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 text-xs font-medium text-slate-500">
            <Link to="/download" className="hover:text-[var(--brand-primary)] transition-colors">Download</Link>
            <span className="text-slate-300">·</span>
            <Link to="/privacy" className="hover:text-[var(--brand-primary)] transition-colors">Privacy Policy</Link>
            <span className="text-slate-300">·</span>
            <Link to="/terms" className="hover:text-[var(--brand-primary)] transition-colors">Terms &amp; Conditions</Link>
            <span className="text-slate-300">·</span>
            <Link to="/support" className="hover:text-[var(--brand-primary)] transition-colors">Support</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
